import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Orders from "./pages/Orders";
import CreateOrder from "./pages/CreateOrder";
import OrderDetail from "./pages/OrderDetail";
import Reminders from "./pages/Reminders";
import Status from "./pages/Status";
import Parties from "./pages/Parties";
import PartyDetail from "./pages/PartyDetail";
import CategoryReport from "./pages/CategoryReport";
import Users from "./pages/Users";
import CommissionRates from "./pages/CommissionRates";
import BuyerMeta from "./pages/BuyerMeta";
import FabricDemand from "./pages/FabricDemand";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready || user === null)
    return <div className="min-h-screen flex items-center justify-center text-slate-400 font-mono text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/orders/new" element={<CreateOrder />} />
              <Route path="/orders/:id" element={<OrderDetail />} />
              <Route path="/reminders" element={<Reminders />} />
              <Route path="/status" element={<Status />} />
              <Route path="/parties" element={<Parties />} />
              <Route path="/parties/detail" element={<PartyDetail />} />
              <Route path="/reports/category" element={<CategoryReport />} />
              <Route path="/users" element={<Users />} />
              <Route path="/commission-rates" element={<CommissionRates />} />
              <Route path="/buyers" element={<BuyerMeta />} />
              <Route path="/admin/analytics/fabric-demand" element={<FabricDemand />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
